document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    cardWishlist();
    swatchImageChange();
    injectGloboSwatchColors();
  }, 2000);
});
window.addEventListener("globoFilterRenderCompleted", function (event) {
  setTimeout(function () {
    cardWishlist();
    swatchImageChange();
    injectGloboSwatchColors();
  }, 2000);
});

function cardWishlist() {
  let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];
  // Initialize all wishlist buttons in grid
  document
    .querySelectorAll(".wishlist-collection-icon")
    .forEach((wishlistBtn) => {
      const productId = wishlistBtn.dataset.productId;
      const variantId = wishlistBtn.dataset.variantId;
      // Find matching remove button (sibling or via data attribute)
      const addedBtn = wishlistBtn
        ?.closest(".card-wishlist-share-wrapper")
        ?.querySelector(".remove-list");
      if (!wishlistBtn || !addedBtn) return;

      // ✅ Detect current color code (if swatches exist in this card)
      let colorcode = "";
      const cardContainer =
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="Color"]') ||
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="color"]');
      const selectedColor = cardContainer?.querySelector(
        ".spf-product__swatch.is-selected"
      )?.dataset?.optionValue;
      if (selectedColor) {
        colorcode = selectedColor;
      }

      // Show correct button on load
      if (wishlist.some((item) => item.variantColor === colorcode)) {
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
      } else {
        wishlistBtn.classList.remove("!hidden");
        addedBtn.classList.add("!hidden");
      }

      // Add to wishlist
      wishlistBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let colorcode = "";
        const cardContainer =
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="Color"]') ||
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="color"]');
        const selectedColor = cardContainer.querySelector(
          ".spf-product__swatch.is-selected"
        )?.dataset?.optionValue;
        if (selectedColor) {
          colorcode = selectedColor;
        }

        const product = {
          id: productId,
          variantId: variantId,
          title: wishlistBtn.dataset.productTitle,
          handle: wishlistBtn.dataset.productHandle,
          variantColor: colorcode,
          addedAt: Date.now()
        };

        wishlist.push(product);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        handleWishlistSyncFlow();
        
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
        // If flyout already exists, remove it first
        const existingFlyout = document.querySelector(
          '[data-testid="my-list-flyout"]'
        );
        if (existingFlyout) existingFlyout.remove();

        // Create flyout HTML
        let flyoutClasses = "";

        let smallMessageHTML = "";
        if (!window.wishlistLabel.customerLoggedIn) {
          smallMessageHTML = `
        <div>
         <p class="catalog-MyListNotifications-module__bigMessage" data-property="GLB_GUEST_ITEM_SAVED">
                <span class="catalog-MyListNotifications-module__heart">
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-anf"></span>
                </span>
                ${window.wishlistLabel.addToWishlist}
              </p>
          <div class="catalog-MyListNotifications-module__smallMessage">
            <p>
              <span data-property="GLB_SIGNIN_HEARTS">
 <modal-opener data-modal="#LoginModal">
        <button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
          <span class="underline">${window.wishlistLabel.signIn}</span>
        </button>
      </modal-opener>${window.wishlistLabel.listSubtext}              </span>
            </p>
            <p>
              <span data-property="GLB_CREATEACCOUNTLINK">
 <modal-opener data-modal="#LoginModal">
        <button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
          <span class="underline">${window.wishlistLabel.createAcc}</span>
        </button>
      </modal-opener>               </span>
            </p>
          </div>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime catalog-MyListNotifications-module__loggedOut";
        } else {
          smallMessageHTML = `
          <div>
             <p class="catalog-MyListNotifications-module__bigMessage">
            <span class="catalog-MyListNotifications-module__heart">
                  
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-anf"></span>

                </span>${window.wishlistLabel.itemSaveLogin}</p>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime";
        }

        // Create flyout HTML with conditional content
        const flyoutHTML = `
        <div data-testid="my-list-flyout" lass="flyout-top-gap">
          <div class="${flyoutClasses}">  
          <div>
              ${smallMessageHTML}
              <p class="catalog-MyListNotifications-module__myListButton block">
                <a class="button" data-full-width="true" data-theme="inverse" data-variant="secondary" href="/pages/my-list">${window.wishlistLabel.viewList}</a>
              </p>
            </div>
          </div>
        </div>
      `;

        // // Insert into header
        // const header = document.querySelector("header");
        // if (header) {
        //   header.insertAdjacentHTML("beforeend", flyoutHTML);
        // }

        // Detect app-view mode
        const isAppView = window.location.search.includes("app-view=true");

        if (isAppView) {
          // Bottom fixed layout for app-view mode
          const appViewFlyout = `
            <div class="app-view-wishlist-flyout">
              <p class="flyout-text">The item has been saved</p>
              <a href="/pages/my-list" class="flyout-btn">My List</a>
            </div>
          `;

  //   const appViewFlyout = `
  //   <div class="app-view-wishlist-flyout">
  //     <p class="flyout-text">The item has been saved</p>
  //   </div>
  // `;
          document.body.insertAdjacentHTML("beforeend", appViewFlyout);

          //Auto-hide after 3 seconds
          setTimeout(() => {
            const flyout = document.querySelector(".app-view-wishlist-flyout");
            if (flyout) flyout.remove();
          }, 3000);
        } else {
          // Default header flyout (desktop/normal collection)
          const header = document.querySelector("header");
          if (header) header.insertAdjacentHTML("beforeend", flyoutHTML);
          // Apply correct gap after flyout is inserted

          toggleFlyoutGap();

          setTimeout(() => {
            const flyout = document.querySelector(
              '[data-testid="my-list-flyout"]'
            );
            if (flyout) flyout.remove();
          }, 3000);
        }

        // Auto-hide after 3 seconds
        setTimeout(() => {
          const flyout = document.querySelector(
            '[data-testid="my-list-flyout"]'
          );
          if (flyout) flyout.remove();
        }, 3000);
      });

      // Remove from wishlist
      addedBtn.addEventListener("click", function () {
        wishlist = wishlist.filter((item) => item.variantColor !== colorcode);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        handleWishlistSyncFlow();
        addedBtn.classList.add("!hidden");
        wishlistBtn.classList.remove("!hidden");
      });
    });
}

function swatchImageChange() {
  document.querySelectorAll(".spf-card-swatch").forEach((swatch) => {
    // Hover to change image
    swatch.addEventListener("mouseenter", (e) => {
      const parentSwatch = e.currentTarget.closest(".spf-product__swatch");
      if (parentSwatch && parentSwatch.classList.contains("sale-filter-hidden")) {
        return;
      }
      e.preventDefault();
      const mediaSrc = e.currentTarget.dataset.mediaSrc;
      const card = e.currentTarget.closest(".card-wrapper");
      if (!card || !mediaSrc) return;

      const mediaContainer = card.querySelector(".card__media .media");
      if (!mediaContainer) return;

      // Remove any previously injected swatch preview image
      const existing = mediaContainer.querySelector(".swatch-preview");
      if (existing) existing.remove();

      // Create a new image
      const newImg = document.createElement("img");
      newImg.src = mediaSrc;
      newImg.className = "swatch-preview";
      newImg.setAttribute("style", "opacity: 1; z-index: 1;");
      newImg.setAttribute("alt", ""); // optional
      newImg.setAttribute("loading", "lazy");
      // Insert before all children (as the first child)
      mediaContainer.insertBefore(newImg, mediaContainer.firstChild);
    });

    // Optional: reset to first image when mouse leaves swatch area
    swatch.addEventListener("mouseleave", (e) => {
      const card = e.currentTarget.closest(".card-wrapper");
      if (!card) return;
      const mediaContainer = card.querySelector(".card__media .media");
      const existing = mediaContainer?.querySelector(".swatch-preview");
      if (existing) existing.remove();
    });
  });
}

/**
 * injectGloboSwatchColors
 * Reads swatch data from DOM elements left behind by Globo's re-render
 * and applies them as background-image styles to the swatch link.
 */
function injectGloboSwatchColors() {
  const swatches = document.querySelectorAll('.spf-product__swatch[data-option-value]');
  swatches.forEach(swatch => {
      if (swatch.dataset.swatchInjected) return;
      
      const optionValue = swatch.getAttribute('data-option-value');
      const swatchElement = swatch.querySelector('.spf-card-swatch');
      if (!swatchElement) return;

      const cdnUrl = "https://cdn.shopify.com/s/files/1/0711/6668/9452/files/";
      const extensions = [".jpg", ".png", ".jpeg"];
      let baseName = "";

      if (optionValue.toLowerCase().includes("pattern")) {
        baseName = optionValue.replace(/[\s/]+/g, "_");
      } else {
        baseName = optionValue.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      }

      const tryLoad = (index) => {
        if (index >= extensions.length) return;
        const extension = extensions[index];
        const bgUrl = `${cdnUrl}${baseName}${extension}`;

        const img = new Image();
        img.onload = () => {
          swatchElement.style.backgroundImage = `url('${bgUrl}')`;
          swatchElement.style.backgroundSize = "cover";
          swatchElement.style.backgroundRepeat = "no-repeat";
          swatchElement.style.backgroundPosition = "center";
          swatchElement.classList.add("is-injected");
        };
        img.onerror = () => tryLoad(index + 1);
        img.src = bgUrl;
      };

      tryLoad(0);
      swatch.dataset.swatchInjected = "true";
  });
}

// ---------- Sale collection filtering ----------
(function () {
  "use strict";

  let isFiltering = false;
  let filterTimeout = null;

  function runFilterOptimized() {
    if (isFiltering) return;

    if (isSearchTemplate()) {
      showAllProductCards();
      return;
    }

    isFiltering = true;
    requestAnimationFrame(function () {
      filterVariantsBySaleMetafield().finally(function () {
        isFiltering = false;
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runFilterOptimized, { once: true });
  } else {
    runFilterOptimized();
  }

  window.addEventListener(
    "globoFilterRenderCompleted",
    function () {
      if (filterTimeout) clearTimeout(filterTimeout);
      filterTimeout = setTimeout(runFilterOptimized, 50);
    },
    { passive: true }
  );

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(runFilterOptimized, 600);
  });
})();

async function filterVariantsBySaleMetafield() {
  const urlPath = window.location.pathname;

  if (isSearchTemplate()) {
    showAllProductCards();
    return;
  }

  const productCards = document.querySelectorAll(".product-card-wrapper[data-product-id]");
  if (productCards.length === 0) return;

  const productData = [];
  productCards.forEach((card) => {
    const productId = card.dataset.productId;
    const variantsData = card.dataset.variantsMetafield || "";
    const listItem = card.closest("li");
    if (productId && variantsData && listItem) {
      productData.push({ card, productId, variantsData, listItem });
    }
  });

  if (productData.length === 0) {
    showAllProductCards();
    return;
  }

  const metafields = {};
  productData.forEach(({ productId, variantsData }) => {
    metafields[productId] = {};
    variantsData.split(",").forEach((variantEntry) => {
      const [variantId, isOnSaleStr] = variantEntry.split(":");
      if (variantId) {
        metafields[productId][variantId] = {
          is_on_sale: isOnSaleStr === "true",
        };
      }
    });
  });

  const isSaleCollection = detectSaleCollection(urlPath);

  const toShow = [];
  const toHide = [];

  productData.forEach(({ card, productId, listItem }) => {
    const productMetafields = metafields[productId] || {};
    const defaultVariantId = getDefaultVariantId(card);

    let hasSaleVariant = false;
    for (const variantId in productMetafields) {
      if (productMetafields[variantId].is_on_sale) {
        hasSaleVariant = true;
        break;
      }
    }

    const defaultIsSale =
      defaultVariantId && productMetafields[defaultVariantId]
        ? productMetafields[defaultVariantId].is_on_sale === true
        : false;

    let shouldShow;
    if (isSaleCollection) {
      shouldShow = defaultVariantId ? defaultIsSale : hasSaleVariant;
    } else {
      shouldShow = defaultVariantId ? !defaultIsSale : !hasSaleVariant;
    }

    if (shouldShow) {
      toShow.push({ listItem, card, productMetafields });
    } else {
      toHide.push({ listItem, card });
    }
  });

  requestAnimationFrame(function () {
    toHide.forEach(({ listItem, card }) => {
      listItem.classList.remove("sale-filter-visible");
      hideAllSwatches(card);
    });

    toShow.forEach(({ listItem, card, productMetafields }) => {
      listItem.classList.add("sale-filter-visible");
      filterSwatchesForCard(card, productMetafields, isSaleCollection);
    });
  });
}

function detectSaleCollection(urlPath) {
  const collectionHandle = urlPath.match(/\/collections\/([^/?]+)/)?.[1] || "";
  return (
    urlPath.includes("/sale") ||
    urlPath.includes("/collections/sale") ||
    collectionHandle.includes("sale") ||
    document.documentElement.getAttribute("data-is-sale-collection") === "true" ||
    window.SHOPIFY_SALE_COLLECTION === true
  );
}

function getDefaultVariantId(card) {
  const selectedSwatch = card.querySelector(".spf-product__swatch.is-selected a.spf-product__swatch-link");
  if (selectedSwatch) {
    const match = selectedSwatch.href.match(/variant=(\d+)/);
    if (match) return match[1];
  }

  const productLink = card.querySelector('a[href*="/products/"][href*="variant="]');
  if (productLink) {
    const match = productLink.href.match(/variant=(\d+)/);
    if (match) return match[1];
  }

  const quickAddButton = card.querySelector("[data-variant-id]");
  if (quickAddButton) {
    return quickAddButton.getAttribute("data-variant-id");
  }

  return null;
}

function hideAllSwatches(card) {
  card.querySelectorAll(".spf-product__swatch").forEach((swatch) => hideSwatchElement(swatch));
}

function filterSwatchesForCard(card, productMetafields, isSaleCollection) {
  const swatches = card.querySelectorAll(".spf-product__swatch");
  const swatchesLength = swatches.length;

  for (let i = 0; i < swatchesLength; i++) {
    const swatch = swatches[i];
    const swatchLink = swatch.querySelector("a.spf-product__swatch-link");
    if (!swatchLink) {
      resetSwatchStyles(swatch);
      continue;
    }

    const match = swatchLink.href.match(/variant=(\d+)/);
    if (!match) {
      resetSwatchStyles(swatch);
      continue;
    }
    const variantId = match[1];
    const variantMetafield = productMetafields[variantId];

    if (!variantMetafield) {
      resetSwatchStyles(swatch);
      continue;
    }

    const shouldDisplay = isSaleCollection ? variantMetafield.is_on_sale : !variantMetafield.is_on_sale;
    if (shouldDisplay) {
      resetSwatchStyles(swatch);
    } else {
      hideSwatchElement(swatch);
    }
  }
}

function hideSwatchElement(swatch) {
  swatch.classList.add("sale-filter-hidden");
  swatch.style.display = "none";
  swatch.style.visibility = "hidden";
  swatch.style.pointerEvents = "none";
  swatch.style.width = "0";
  swatch.style.height = "0";
  swatch.style.minWidth = "0";
  swatch.style.maxWidth = "0";
  swatch.style.margin = "0";
  swatch.style.padding = "0";
  swatch.style.overflow = "hidden";
  swatch.style.flex = "0 0 0";
  swatch.style.flexBasis = "0";
  swatch.style.flexGrow = "0";
  swatch.style.flexShrink = "0";
  swatch.style.border = "none";
  swatch.style.position = "absolute";
  swatch.style.left = "-9999px";
}

function resetSwatchStyles(swatch) {
  swatch.classList.remove("sale-filter-hidden");
  swatch.style.display = "";
  swatch.style.visibility = "";
  swatch.style.pointerEvents = "";
  swatch.style.width = "";
  swatch.style.height = "";
  swatch.style.minWidth = "";
  swatch.style.maxWidth = "";
  swatch.style.margin = "";
  swatch.style.padding = "";
  swatch.style.overflow = "";
  swatch.style.flex = "";
  swatch.style.flexBasis = "";
  swatch.style.flexGrow = "";
  swatch.style.flexShrink = "";
  swatch.style.border = "";
  swatch.style.position = "";
  swatch.style.left = "";
}

function isSearchTemplate() {
  const urlPath = window.location.pathname;
  return (
    urlPath.includes("/search") ||
    urlPath.includes("/pages/search") ||
    document.body.classList.contains("template-search") ||
    document.body.classList.contains("search") ||
    window.location.search.includes("q=") ||
    document.documentElement.getAttribute("data-template") === "search"
  );
}

function showAllProductCards() {
  const listItems = document.querySelectorAll(
    "#gf-products li.grid__item, #product-grid li.grid__item, ul#product-grid li.grid__item"
  );
  listItems.forEach((item) => {
    item.classList.add("sale-filter-visible");
    item.style.display = "";
    item.style.visibility = "";
  });

  const swatches = document.querySelectorAll(".spf-product__swatch.sale-filter-hidden");
  swatches.forEach((swatch) => resetSwatchStyles(swatch));
}


const headerFlyoutSelector = '[data-testid="my-list-flyout"]';

function toggleFlyoutGap() {
  const flyoutWrapper = document.querySelector(headerFlyoutSelector);
  if (!flyoutWrapper) return;
  const flyoutBox = flyoutWrapper.querySelector(
    ".catalog-MyListNotifications-module__flyout"
  );
  if (!flyoutBox) return;
  if (window.scrollY > 10) {
    flyoutBox.classList.remove("flyout-top-gap");
  } else {
    flyoutBox.classList.add("flyout-top-gap");
  }
}
window.addEventListener("scroll", toggleFlyoutGap);
document.addEventListener("DOMContentLoaded", toggleFlyoutGap);
